import { useState } from "react";

import useSelectedMinerAccount from "../../../hooks/useSelectedMinerAccount";
import LinkedInAccountFormField from "../LinkedInAccountFormField";
import ScrollAndFooter from "../ScrollAndFooter";
import EventFormField from "./EventFormField";
import SelectedEvent from "./SelectedEvent";

import type {
  EventLeadListSource,
  LinkedInEvent as EventType,
} from "../../../types";

import EventImage from "assets/images/sources/event.png";

interface EventProps {
  createSource: (params: {
    miner: string;
    settings: EventLeadListSource["settings"];
  }) => void;
  isCreatingSource: boolean;
}

export default function Event({ createSource, isCreatingSource }: EventProps) {
  const { setMinerAccountId, minerAccountId } = useSelectedMinerAccount();
  const [selectedEvent, setSelectedEvent] = useState<EventType>();

  return (
    <ScrollAndFooter
      isCreateDisabled={!selectedEvent}
      isCreatingSource={isCreatingSource}
      onCreate={() =>
        createSource({
          miner: minerAccountId,
          settings: { type: "event", event_id: selectedEvent.id },
        })
      }
    >
      <div className="flex flex-col gap-y-3 lg:gap-y-6 max-w-135 m-auto">
        <div className="flex gap-3 lg:gap-5 max-lg:order-3 flex-col lg:flex-row">
          <LinkedInAccountFormField
            accountId={minerAccountId}
            setAccountId={setMinerAccountId}
          />
          <EventFormField
            accountId={minerAccountId}
            selectedEvent={selectedEvent}
            onSelect={setSelectedEvent}
          />
        </div>

        {selectedEvent ? (
          <SelectedEvent accountId={minerAccountId} event={selectedEvent} />
        ) : (
          <img src={EventImage} alt="" height={238} />
        )}
      </div>
    </ScrollAndFooter>
  );
}
